import { SelectItem } from 'primeng/api';

export enum UserType {
  Internal = 'INTERNAL',
  Company = 'COMPANY',
  Vendor = 'VENDOR',
}

export const USER_TYPES: SelectItem[] = [
  { label: 'Project Manager', value: UserType.Internal },
  { label: 'Client', value: UserType.Company },
  { label: 'Vendor', value: UserType.Vendor },
];
